import $ from 'jquery'

export default class SignatureForm {

  constructor(selector) {
    this.$form = $(selector)
    this.$checkbox = this.$form.find('input[type=checkbox]')
    this.$btn = this.$form.find('button[type=submit]')
    this.init()

  }

  init() {
    this.$checkbox.on('change', () => this.on_change())
    this.$checkbox.prop('checked', false)
    this.$btn.prop('disabled', true)
  }

  on_change() {
    if(this.$checkbox.is(':checked')) {
        this.$btn.prop('disabled', false)
    } else {
        this.$btn.prop('disabled', true)            
    }
  }

}



// WEBPACK FOOTER //
// ./utils/static/utils/js/signature-form.js